import { Model } from "../../interfaces";
import { getPropertiesNames } from "../getMethods";

export const filterByName = (list: Model[], inputValue: string) => {
  let finalArray: Model[] = [];
  list.forEach((model) => {
    if (
      model.bio.name.toLowerCase().includes(inputValue.toLowerCase()) ||
      model.bio.surname.toLowerCase().includes(inputValue.toLowerCase())
    ) {
      finalArray.push(model);
    }
  });
  return finalArray;
};

export const filterBySliderField = (
  list: Model[],
  form: Object,
  modelPropSection: string
) => {
  let finalArray: Model[] = [];
  let finalFilterPropertiesList: any[] = [];
  const modelMeasuresTemplate: Model["measures"] = {
    height: 0,
    bust: 0,
    hips: 0,
    waist: 0,
    shoes: 0,
    eyes: "",
    hair: "",
  };
  const modelWorkCategoriesTemplate: Model["work_categories"] = {
    campaign: 0,
    catalog: 0,
    digital: 0,
    editorial: 0,
    look_book: 0,
    show: 0,
    showroom: 0,
    tv_commercial: 0,
    shooting: 0,
    fashion_show: 0,
    event: 0,
    casting: 0,
  };

  let finalFilterPropertiesNames = getPropertiesNames(
    modelMeasuresTemplate,
    "exclude",
    ["eyes", "hair"]
  );

  if (modelPropSection === "measures") {
    finalFilterPropertiesNames = getPropertiesNames(
      modelMeasuresTemplate,
      "exclude",
      ["eyes", "hair"]
    );
  } else if (modelPropSection === "work_categories") {
    finalFilterPropertiesNames = getPropertiesNames(
      modelWorkCategoriesTemplate
    );
  }

  const formEntries = Object.entries(form);
  finalFilterPropertiesNames.forEach((propName) => {
    let min = 0;
    let max = 0;
    formEntries.forEach((formField) => {
      const name = formField[0];
      const value = formField[1];
      if (name.includes(propName + "_min")) {
        min = value;
      }
      if (name.includes(propName + "_max")) {
        max = value;
      }
    });
    finalFilterPropertiesList.push({ name: propName, min: min, max: max });
  });

  const sectionSelected = (model: Model) => {
    if (modelPropSection === "measures") {
      return model.measures;
    } else if (modelPropSection === "work_categories") {
      return model.work_categories;
    }
  };

  list.forEach((model) => {
    let tempModel: Model | null = null;
    const conditions: boolean[] = [];

    const modelEntries = Object.entries(sectionSelected(model)!);
    modelEntries.forEach((modelField) => {
      const isHairEyes = modelField[0] === "hair" || modelField[0] === "eyes";
      const modelFieldName = modelField[0];
      const modelFieldValue = modelField[1];
      let filterFieldName = "";
      let filterFieldMin = 0;
      let filterFieldMax = 0;
      if (isHairEyes) {
      } else {
        finalFilterPropertiesList.forEach((field) => {
          if (field.name === modelFieldName) {
            filterFieldName = field.name;
            filterFieldMin = field.min;
            filterFieldMax = field.max;
          }
        });
        if (typeof modelFieldValue != "string") {
          if (
            modelFieldName === filterFieldName &&
            modelFieldValue >= filterFieldMin &&
            modelFieldValue <= filterFieldMax
          ) {
            conditions.push(true);
            tempModel = model;
          } else {
            conditions.push(false);
            tempModel = null;
          }
        }
      }
    });

    const proceed = conditions.every((cond) => cond === true);
    if (tempModel !== null && proceed && formEntries.length != 0) {
      finalArray.push(tempModel);
    } else if (formEntries.length === 0) {
      finalArray = list;
    }
  });

  return finalArray;
};

export const filterByTraits = (list: Model[], inputValues: Object) => {
  let finalArray: Model[] = [];
  const modelMeasuresTemplate: Model["measures"] = {
    height: 0,
    bust: 0,
    hips: 0,
    waist: 0,
    shoes: 0,
    eyes: "",
    hair: "",
  };
  const modelPropNames = getPropertiesNames(modelMeasuresTemplate, "exclude", [
    "height",
    "waist",
    "bust",
    "hips",
    "shoes",
  ]);

  let chosenEyesColorsArray: string[] = [];
  let chosenHairColorsArray: string[] = [];
  modelPropNames.forEach((modelPropName) => {
    const firstPropLetter = modelPropName.slice(0, 1).toLocaleLowerCase();
    const inputValuesEntries = Object.entries(inputValues);
    inputValuesEntries.forEach((el) => {
      const valueToMatch = el[0]
        .charAt(2)
        .toUpperCase()
        .concat(el[0].slice(3, el[0].length));
      if (firstPropLetter === "e" && el[0][0] === "e" && el[1]) {
        chosenEyesColorsArray.push(valueToMatch);
      }
      if (firstPropLetter === "h" && el[0][0] === "h" && el[1]) {
        chosenHairColorsArray.push(valueToMatch);
      }
    });
  });
  list.forEach((model) => {
    let eyesMatch = false;
    chosenEyesColorsArray.forEach((color) => {
      if (model.measures.eyes === color) {
        eyesMatch = true;
      }
    });
    let hairMatch = false;
    chosenHairColorsArray.forEach((color) => {
      if (model.measures.hair === color) {
        hairMatch = true;
      }
    });

    if (eyesMatch || hairMatch) {
      finalArray.push(model);
    }
  });
  if (
    chosenHairColorsArray.length === 0 &&
    chosenEyesColorsArray.length === 0
  ) {
    finalArray = list;
  }

  const inputValuesEntries = Object.entries(inputValues);
  const allOff = inputValuesEntries.every((entry) => {
    return entry[1] === false;
  });

  if (allOff) {
    return null;
  } else return finalArray;
};

export const filterByPlace = (list: Model[], inputValues: Object) => {
  let finalArray: Model[] = [];
  const inputChoice: any = [];
  Object.entries(inputValues).forEach((item) => {
    if (item[1] === true) {
      inputChoice.push(item[0]);
    }
  });
  list.forEach((model) => {
    const placeValue = (place: string) => {
      let convertedPlaceString = "";
      if (place === "In town") convertedPlaceString = "in_town";
      if (place === "Italy") convertedPlaceString = "italy";
      if (place === "Europe") convertedPlaceString = "europe";
      if (place === "Worldwide") convertedPlaceString = "worldwide";
      return convertedPlaceString;
    };
    const finalPlaceValue = placeValue(model.bio.place);
    if (inputChoice.includes(finalPlaceValue)) {
      finalArray.push(model);
    }
  });
  if (finalArray.length <= 0) {
    return null;
  } else return finalArray;
};

export const finalFilter = (
  modelsFetched: Model[],
  filteredByName?: Model[],
  filteredByMeasures?: Model[] | null,
  filteredByTraits?: Model[] | null,
  filteredByCategory?: Model[] | null,
  filterByPlace?: Model[] | null
) => {
  let modelsTreated = modelsFetched;

  if (filteredByName && filterByName.length > 0) {
    modelsTreated = filteredByName;
  }

  if (filterByPlace && filterByPlace.length > 0) {
    if (filteredByName) {
      modelsTreated = modelsTreated.filter((model) =>
        filterByPlace.includes(model)
      );
    } else modelsTreated = filterByPlace;
  }

  if (filteredByTraits) {
    if (filteredByName) {
      modelsTreated = modelsTreated.filter((model) =>
        filteredByTraits.includes(model)
      );
    } else modelsTreated = filteredByTraits;
  }

  if (filteredByMeasures && filteredByMeasures.length > 0) {
    modelsTreated = modelsTreated.filter((model) =>
      filteredByMeasures.includes(model)
    );
  } else if (filteredByMeasures && filteredByMeasures.length === 0) {
    modelsTreated = [];
  }

  if (filteredByCategory && filteredByCategory.length > 0) {
    modelsTreated = modelsTreated.filter((model) =>
      filteredByCategory.includes(model)
    );
  } else if (filteredByCategory && filteredByCategory.length === 0) {
    modelsTreated = [];
  }

  return modelsTreated;
};
